"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FlexModal = _interopRequireDefault(require("./FlexModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var FlexTitle = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var title = props.title,
    mergeComponentStatus = props.mergeComponentStatus,
    desc = props.desc,
    styles = props.styles,
    className = props.className,
    _a = props.buyType,
    buyType = _a === void 0 ? '' : _a,
    flexSmallTitle = props.flexSmallTitle,
    _b = props.modalList,
    modalList = _b === void 0 ? [] : _b,
    _c = props.lightTheme,
    lightTheme = _c === void 0 ? false : _c,
    paddingTopNum = props.paddingTopNum,
    restProps = __rest(props, ["title", "mergeComponentStatus", "desc", "styles", "className", "buyType", "flexSmallTitle", "modalList", "lightTheme", "paddingTopNum"]);
  var isShowDesc = desc && desc !== '<p></p>'; // 过滤富文本空字符
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    style: styles || {},
    className: (0, _classnames["default"])('global-flex-title', {
      'flex-default-not-title-container': !title,
      'flex-default-not-title-container--mr': mergeComponentStatus,
      'flex-default-add-small-tltle': flexSmallTitle,
      'no-padding-top': paddingTopNum === '0',
      'padding-top-24': paddingTopNum === '24',
      'padding-top-40': paddingTopNum === '40',
      'padding-top-60': paddingTopNum === '60'
    }, className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('span', {
      'tci-mr-class': mergeComponentStatus,
      'aduiovb-theme': ['audiovb'].includes(buyType),
      'light-theme': lightTheme
    })
  }, title), isShowDesc ? (/*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('resource-desc', {
      'light-theme': lightTheme
    }),
    dangerouslySetInnerHTML: {
      __html: desc || ''
    }
  })) : null, modalList.length > 0 && /*#__PURE__*/_react["default"].createElement(_FlexModal["default"], {
    modalList: modalList
  }), flexSmallTitle ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-small-title', {
      'light-theme': lightTheme
    })
  }, flexSmallTitle)) : null);
});
FlexTitle.displayName = 'TCIThumbnail';
var _default = exports["default"] = FlexTitle;